var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1531_3815)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99992 13.3333H11.9999C12.3666 13.3333 12.6666 13.6333 12.6666 14C12.6666 14.3667 12.3666 14.6667 11.9999 14.6667H3.99992C3.63325 14.6667 3.33325 14.3667 3.33325 14C3.33325 13.6333 3.63325 13.3333 3.99992 13.3333ZM7.99992 4.66666C7.26659 4.66666 6.66659 5.26666 6.66659 6C6.66659 6.73333 7.26659 7.33333 7.99992 7.33333C8.35354 7.33333 8.69268 7.19285 8.94273 6.9428C9.19278 6.69276 9.33325 6.35362 9.33325 6C9.33325 5.64637 9.19278 5.30723 8.94273 5.05719C8.69268 4.80714 8.35354 4.66666 7.99992 4.66666ZM7.99992 1.33333C10.1799 1.33333 12.6666 2.97333 12.6666 6.09999C12.6666 8.08666 11.2466 10.18 8.40659 12.36C8.16658 12.5467 7.83325 12.5467 7.59325 12.36C4.75325 10.1733 3.33325 8.08666 3.33325 6.09999C3.33325 2.97333 5.81992 1.33333 7.99992 1.33333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.41abc2ddf617e38bcf83993043846346.svg";
export { ForwardRef as ReactComponent };